<template>
	<div class="DonutChart__wrapper Chart--inline" v-if="chartData">
		<donut-chart
			:chart-data="chartData"
			:chart-options="chartOptions"
		></donut-chart>
		<div
			v-if='chartInnerText == "percentage_positive_votes"'
			class="DonutChart__inner-text"
		>
			<div class="DonutChart__inner-text--main">
				{{ calculatePositiveRatingsPercentage() }}%
			</div>
			<div class="DonutChart__inner-text--sub">{{ approvalText }}</div>
		</div>
	</div>
</template>

<script>
import DonutChart from "../global_components/graphs_and_visualizations/donut_chart.vue";
// Other components
import { i18n } from "../utils";

export default {
	mixins: [i18n],
	props: {
		chartInnerText: String,
		draftId: Number,
		srvRatingsData: Object,
		maxRatings: Number,
		approvalText: String,
	},
	components: {
		"donut-chart": DonutChart,
	},
	data: function () {
		return {
			ratingsData: this.srvRatingsData,
			chartOptions: {
				cutout: "84%",
				responsive: true,
				maintainAspectRatio: true,
				aspectRatio: 1,
				plugins: {},
			},
		};
	},
	computed: {
		pieLabels() {
			// @ts-expect-error
			return _.map(Object.values(this.ratingsData), (valueHash) => {
				return valueHash.label;
			});
		},
		pieColors() {
			// @ts-expect-error
			return Object.values(this.ratingsData)
				.map(({ css_selector }) => {
					// NB this will convert an I18n string, e.g. 'plenary.affirmative_votes', to a css selector, e.g. 'plenary-affirmative_votes'
					return pp.viewHelpers.detectCssRuleFor(
						`.Ratings__actors-breakdown--${css_selector} .Ratings__actors-breakdown-header`,
						"color",
					);
				})
				.concat(
					pp.viewHelpers.detectCssRuleFor(
						`.bg-theme-light-l2`,
						"background-color",
					),
				); // Need to add the neutral color for uncast votes
		},
		pieData() {
			// @ts-expect-error
			let data = Object.values(this.ratingsData).map(
				({ ratings_count }) => ratings_count,
			);
			if (this.maxRatings == 0) {
				data.push(1); // Need to show something in the donut
			} else {
				// @ts-expect-error
				data.push(this.maxRatings - _.sum(data));
			}
			return data;
		},
		chartData() {
			return {
				datasets: [
					{
						backgroundColor: this.pieColors,
						data: this.pieData,
						labels: this.pieLabels,
					},
				],
			};
		},
	},
	mounted() {
		pp.vue.bus.$on("rating-CREATE", this.handleIncomingRating);
		pp.vue.bus.$on(
			"article-MAXRATINGSUPDATE",
			this.handleIncomingMaxRatingsUpdate,
		);
	},
	beforeDestroy() {
		pp.vue.bus.$off("rating-CREATE", this.handleIncomingRating);
		pp.vue.bus.$off(
			"article-MAXRATINGSUPDATE",
			this.handleIncomingMaxRatingsUpdate,
		);
	},
	methods: {
		calculatePositiveRatingsPercentage() {
			let positiveRatingCount = 0;
			let totalVotesCount = 0;
			// @ts-expect-error
			Object.entries(this.ratingsData).forEach(([rating_value, valueHash]) => {
				totalVotesCount += valueHash.ratings_count;
				if (parseInt(rating_value, 10) > 0) {
					positiveRatingCount += valueHash.ratings_count;
				}
			});
			if (positiveRatingCount == 0) {
				return 0;
			}
			return Math.round((positiveRatingCount / totalVotesCount) * 100);
		},
		handleIncomingRating(rating) {
			if (this.draftId != rating.rateable_id) {
				return; // Is for another Draft
			}
			// @ts-expect-error
			Object.keys(this.ratingsData).forEach((rating_value) => {
				const ratingValueAsInt = parseInt(rating_value);
				if (ratingValueAsInt == rating.rating) {
					// @ts-expect-error
					this.ratingsData[rating_value].ratings_count += 1;
				}
			});
		},
		handleIncomingMaxRatingsUpdate(updateObj) {
			if (this.draftId != updateObj.draft_id) {
				return; // Is for another Draft
			}
			// @ts-expect-error
			this.maxRatings = updateObj.max_ratings;
		},
	},
};
</script>
